import { getSession } from "../utils/functions";
import { hasValidCardLength } from "../utils/cardBinDetector";
const PersonasState = require("./Personas.js");
const PlusState = require("./UrgPlus.js");
const EmpresasState = require("./Empresas.js");
const ConectaState = require("./Conecta.js");

const state = {
  Loading:true,
  LoadingResources:false,
  Resources:undefined,
  Error:undefined,
  Categories:undefined,
  Loading:false,
  rules: {
    required: value => !!value || 'Requerido.',
    noSpecialCharsSP: value => {
      if(!value) return true;
      const pattern = /[\/\\\\'"]/;
      return !pattern.test(String(value)) || 'No se permiten los caracteres /, \\, comillas simples ni dobles.';
    },
    email: value => 
    {
      if(!value) return true; // Skip validation if empty (required rule will handle it)
      
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || 'Por favor verifique la dirección de email provista.'
    },

    nameLength: value => {
      if(!value) {
        return true; // Skip validation if empty (required rule will handle it)
      }
      
      // Check if it's only letters (including spaces for names like "María José")
      const pattern = /^[a-zA-ZñÑçÇáéíóúÁÉÍÓÚüÜ\s]+$/;
      if (!pattern.test(value)) {
        return 'Sólo letras permitidas.';
      }
      
      // Check length between 3 and 50 characters
      if (value.length < 3) {
        return 'El nombre debe tener al menos 3 caracteres.';
      }
      
      if (value.length > 50) {
        return 'El nombre no puede exceder 50 caracteres.';
      }
      
      return true;
    },
    onlyNumbers: value => {
      if(!value) return true; // Skip validation if empty (required rule will handle it)
      const pattern = /^[0-9]+$/;
      return pattern.test(value) || 'Sólo números permitidos.';
    },
    postalCode: value => {
      if(!value) return true;
      const pattern = /^[0-9]{4}$/;
      return pattern.test(String(value)) || 'Debe ser de 4 dígitos (solo números).';
    },
    ageRange: value => {
      if(!value) return true; // Skip validation if empty (required rule will handle it)
      const age = parseInt(value);
      if(isNaN(age)) return 'Debe ser un número válido.';
      if(age < 0 || age > 120) return 'La edad debe estar entre 0 y 120 años.';
      return true;
    },
    onlyLetters: value =>
    {
      const pattern = /^[a-zA-ZñÑçÇ\s]*$/;
      return pattern.test(value) || "Sólo letras.";
    },
    uniqueDocument: value => 
    {
      const Members = PersonasState.default.getters.getMembersDocuments(PersonasState.default.state);
      const DnisRepetidos = Members.filter(document => document === value);
      if(DnisRepetidos.length > 0) return "El documento ya se encuentra registrado";

      return true;
    },
    uniqueDocumentEdit: value => 
    {
      const Members = PersonasState.default.getters.getMembersDocuments(PersonasState.default.state);
      const DnisRepetidos = Members.filter(document => document === value);
      if(DnisRepetidos.length > 1) 
        return "El documento ya se encuentra registrado";

      return true;
    },
    uniqueDocumentPlus: value => 
      {
        const Members = PlusState.default.getters.getMembersDocuments(PlusState.default.state);
        const DnisRepetidos = Members.filter(document => document === value);
        if(DnisRepetidos.length > 0) return "El documento ya se encuentra registrado";
  
        return true;
      },
      uniqueDocumentEditPlus: value => 
      {
        const Members = PlusState.default.getters.getMembersDocuments(PlusState.default.state);
        const DnisRepetidos = Members.filter(document => document === value);
        if(DnisRepetidos.length > 1) 
          return "El documento ya se encuentra registrado";
  
        return true;
      },
    card: value =>
    {
      if(!hasValidCardLength(value)) return "Por favor verifique el número de tarjeta provisto.";
    },
    expires: value =>
    {
      if(value.length !== 5) return "Por favor verifique el vencimiento provisto.";
    },
    cvv: value =>
    {
      if(!value || (value.length !== 3 && value.length !== 4)) return "Por favor verifique el CVV provisto (debe ser de 3 o 4 dígitos).";
    },
    date: value =>
    {
      const Partes = String(value).split("-");
      if (Partes.length > 2)
      {
        const Year = Partes[0];
        const ActualYear = new Date().getFullYear();
        if(Number(Year) > ActualYear)
        {
          return "Por favor verifique el año provisto."
        }

        if(Year.length > 4)
        {
          return "Por favor verifique el año provisto."
        }
        if(!Year.startsWith("1") && !Year.startsWith("2"))
        {
          return 'Por favor verifique el año provisto.'
        }

        var fecha = new Date();
        var fechaNacimiento = new Date(value);
        var edad = fecha.getFullYear() - fechaNacimiento.getFullYear();
        var m = fecha.getMonth() - fechaNacimiento.getMonth();
        if (m < 0 || (m === 0 && fecha.getDate() < fechaNacimiento.getDate())) 
        {
          return edad--;
        }
        if(edad < 0)
        {
          return "Por favor verifique la fecha provista."
        }
      }
      
    },
    month:value =>
    {
      const Partes = String(value).split("-");
  
      if(Partes.length !== 2)
      {
        return "Por favor verifique el año provisto."
      }
      else
      {     
        const Ahora = new Date();
        const ActualYear = Ahora.getFullYear();
        const ActualMes = Ahora.getMonth();
          
        const MesInput = Partes[1];
        const YearInput = Partes[0];

        if(YearInput.startsWith("0"))
        {
          return "Requerido."
        }

        if(YearInput < ActualYear)
        {
          return "Tarjeta vencida"
        }

        if(YearInput == ActualYear)
        {
          if(MesInput < (ActualMes + 1))
          {
            return "Tarjeta vencida"
          }
        }

        return true;
      }
    },
    minLength:(value,length ) => 
    {
      return value.length >= length || `Minimo ${length} caracteres.`
    },
    maxLength:(value,length ) => 
    {
      return value.length <= length || `Máximo ${length} caracteres.`
    },
    sameEmail:(value,otherValue) =>
    {
      return value === otherValue || "Los emails no coinciden."
    },
    sameDocument:(value, otherValue) => {

      return value == EmpresasState.default.state.Documento || "El dni debe ser el mismo que el del responsable."
    }
  },
  Payment:
  {
    Credit:
    {
      Card:"",
      Token:"",
      CVV:"",
      Expires:"",
      FirstName:"",
      LastName:"",
      DocumentType:"",
      DocumentNumber:"",
      Email:"",
      EmailConfirm:"",
      Birthdate:"",
      Company: undefined,
      Companies:
      [
        {
          id: 1,
          title: "Visa",
        },
        {
          id: 104,
          title: "Mastercard",
        },
        {
          id: 24,
          title: "Naranja",
        },
        {
          id: 65,
          title: "American Express",
        }
      ],
      VisaDebitRegex: null,
      Errors:
      {
        Card: "",
        Expires: "",
        CVV: "",
        DebitCard: ""
      }
    },
    Debit:
    {
      CBU:"",
      FirstName:"",
      LastName:"",
      DocumentType:"",
      DocumentNumber:"",
      Email:"",
      EmailConfirm:""
    }
  },
  Sources:
  {
    utm_tracking:undefined,
    utm_source:undefined,
    branch:undefined,
    codigoPromotor:undefined,
    gclid:undefined,
  }
};


const MiscState =
{
  namespaced:true,
  state,
  getters:
  {
    async getResources(state)
    {

      try 
      {
        state.LoadingResources = true;
        
        const Session = getSession();

        const { data: resources  } = await Session.get("/resources/");
        const { data: categories } = await Session.get("/ap/categories/");
        const { data: config } = await Session.get("/config/");

        state.Categories = categories;
        state.Resources = resources;
        state.Config = config;

        const promosBancariasConfig = config.find(item => item.name === "PROMOS_BANCARIAS");
        state.PromosBancarias = promosBancariasConfig ? promosBancariasConfig.value : null;

        state.LoadingResources = false;

      } catch (error) {
        console.log(error);
      }


    },
    getCard(state)
    {
      return state.Payment.Credit;
    },
    getBank(state)
    {
      return state.Payment.Debit;
    },
    getLoading(state)
    {
      return state.Loading;
    },
    getLoadingResources(state)
    {
      return state.LoadingResources;
    },
    getMinPricePersonas(state)
    {
      const precio = state.Resources?.plus_prices?.[0]?.price;
      return precio != null ? Number(precio) : 0;
    },
    getZoneId: (state) => (payload) =>
    {
      const { zones } = state.Resources;
      if(zones.length === 0) return null;

      const zone = zones.find(z => z.title === payload);
      return zone ? zone.id : null;
    }
  },
  mutations:
  {
    setPromocion(state,payload)
    {
      const {title,discount} = payload;

      const {ap_prices,prices} = state.Resources;

      for (let index = 0; index < ap_prices.length; index++) 
      {
        const ap_price = ap_prices[index];
        ap_price.price = Number(ap_price.price - (ap_price.price * discount / 100)).toFixed(2);
      }

      for (let index = 0; index < prices.length; index++)
      {
        const price = prices[index];
        price.discount = Number(discount).toFixed(2);
        price.discount_comment = title;
        price.price = Number(price.price - (price.price * discount / 100)).toFixed(2);;
      }
    },
    setSource(state, {key,value})
    {
      state.Sources[key] = value;
    },
    setLoading(state, value)
    {
      state.Loading = value;
    },
    setError(state,payload)
    {
      state.Error = payload;
    },
    updateValuePaymentCredit(state, {key,value})
    {
      state.Payment.Credit[key] = value;
    },
    updateValuePaymentDebit(state, {key,value})
    {
      state.Payment.Debit[key] = value;
    },
    setCreditErrors(state, payload)
    {
      state.Payment.Credit.Errors = { ...state.Payment.Credit.Errors, ...payload };
    },
    clearCreditErrors(state)
    {
      state.Payment.Credit.Errors = { Card: "", Expires: "", CVV: "", DebitCard: "" };
    },
    setCardCompanyFromBin(state, company)
    {
      state.Payment.Credit.Company = company;
    },
    setVisaDebitRegex(state, regex)
    {
      state.Payment.Credit.VisaDebitRegex = regex;
    },
    setDebitCardError(state, msg)
    {
      state.Payment.Credit.Errors.DebitCard = msg;
    }
  }
}

export default MiscState